/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';

import Input from '../../components/Input';

import BrData from '~/assets/data/brcities.json';
import {
  Container,
  ViewFormPersonal,
  ViewFormPassword,
  ViewFormOthers,
  ViewBottom,
} from './styles';
import { signUpRequest } from '~/store/modules/auth/actions';

const englishLevel = [
  { value: 'nenhum', label: 'Nenhum' },
  { value: 'basico', label: 'Básico' },
  { value: 'intermediario', label: 'Intermediário' },
  { value: 'avancado', label: 'Avançado' },
];

const programming = [
  {
    value: 'nenhum',
    label: 'Nenhum',
  },
  {
    value: 'menos de 1',
    label: 'Menos de 1 ano',
  },
  {
    value: 'menos de 3',
    label: 'Menos de 3 anos',
  },
  {
    value: 'mais de 3',
    label: 'Mais de 3 anos',
  },
];

export default function SignUp() {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const [stateSelected, setStateSelected] = useState('');
  const [citySelected, setCitySelected] = useState('');
  const [englishSelected, setEnglishSelected] = useState('');
  const [programmingSelected, setProgrammingSelected] = useState('');

  async function handleSelectState(e) {
    setStateSelected(e.target.value);
  }

  async function handleSelectCity(e) {
    setCitySelected(e.target.value);
  }

  async function handleSelectEnglish(e) {
    setEnglishSelected(e.target.value);
  }

  async function handleSelectProgramming(e) {
    setProgrammingSelected(e.target.value);
  }

  async function handleSubmit(data) {
    const {
      firstName,
      lastName,
      email,
      birthday,
      password,
      confirmPassword,
    } = data;

    const city = citySelected;
    const state = stateSelected;
    const level = programmingSelected;
    const english = englishSelected;

    if (password.length >= 6) {
      if (password === confirmPassword) {
        dispatch(
          signUpRequest(
            firstName,
            lastName,
            email,
            birthday,
            city,
            state,
            level,
            english,
            password
            // roles
          )
        );
      } else {
        return toast.error('As senhas precisam ser iguais.');
      }
    } else {
      return toast.error('A senha precisa ter pelo menos 6 caracteres.');
    }
  }

  return (
    <Container>
      <h1 style={{ color: '#fff', textAlign: 'center' }}>Realizar Cadastro</h1>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <p
          style={{
            color: '#fff',
            textAlign: 'center',
            marginTop: 40,
            fontSize: 20,
          }}
        >
          Dados Pessoais
        </p>
        <ViewFormPersonal>
          <Input name="firstName" type="text" placeholder="Nome" />
          <Input name="lastName" type="text" placeholder="Sobrenome" />
          <Input name="email" type="email" placeholder="E-mail" />
          <Input
            name="birthday"
            type="date"
            placeholder="Data Nascimento"
            max={new Date().toISOString().split('T')[0]}
          />

          <select value={stateSelected} onChange={handleSelectState}>
            <option value="" disabled>
              Selecione o estado que você mora
            </option>
            {BrData.estados.map((state, index) => (
              <option key={state.sigla} value={index}>
                {state.nome}
              </option>
            ))}
          </select>

          {stateSelected === '' ? null : (
            <select value={citySelected} onChange={handleSelectCity}>
              <option value="" disabled>
                Selecione a cidade que você mora
              </option>
              {BrData.estados[stateSelected].cidades.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          )}
        </ViewFormPersonal>

        <p
          style={{
            color: '#fff',
            textAlign: 'center',
            marginTop: 30,
            fontSize: 20,
          }}
        >
          Conhecimento
        </p>
        <ViewFormOthers>
          <select value={englishSelected} onChange={handleSelectEnglish}>
            <option value="" disabled>
              Selecione o seu nível de inglês
            </option>
            {englishLevel.map((english) => (
              <option key={english.label} value={english.value}>
                {english.label}
              </option>
            ))}
          </select>

          <select
            value={programmingSelected}
            onChange={handleSelectProgramming}
          >
            <option value="" disabled>
              Selecione o seu nível de programaçāo
            </option>
            {programming.map((level) => (
              <option key={level.label} value={level.value}>
                {level.label}
              </option>
            ))}
          </select>
        </ViewFormOthers>

        <p
          style={{
            color: '#fff',
            textAlign: 'center',
            marginTop: 30,
            fontSize: 20,
          }}
        >
          Senha de Acesso
        </p>
        <ViewFormPassword>
          <Input name="password" type="password" placeholder="Senha" />
          <Input
            name="confirmPassword"
            type="password"
            placeholder="Confirmar Senha"
          />
        </ViewFormPassword>

        <ViewBottom>
          <button type="submit">CADASTRAR</button>
          <p>
            Já tem uma conta? <Link to="/"> Fazer login</Link>
          </p>
        </ViewBottom>
      </Form>
    </Container>
  );
}
